import { __read } from "tslib";
import * as u from '@virtuoso.dev/urx';
import { domIOSystem } from './domIOSystem';
import { propsReadySystem } from './propsReadySystem';
import { totalListHeightSystem } from './totalListHeightSystem';
export var initialScrollTopSystem = u.system(function (_a) {
    var _b = __read(_a, 3), totalListHeight = _b[0].totalListHeight, didMount = _b[1].didMount, scrollTo = _b[2].scrollTo;
    var initialScrollTop = u.statefulStream(0);
    u.subscribe(u.pipe(didMount, u.withLatestFrom(initialScrollTop), u.filter(function (_a) {
        var _b = __read(_a, 2), offset = _b[1];
        return offset !== 0;
    }), u.map(function (_a) {
        var _b = __read(_a, 2), offset = _b[1];
        return ({ top: offset });
    })), function (location) {
        u.handleNext(u.pipe(totalListHeight, u.filter(function (val) { return val !== 0; })), function () {
            setTimeout(function () {
                u.publish(scrollTo, location);
            });
        });
    });
    return {
        initialScrollTop: initialScrollTop,
    };
}, u.tup(totalListHeightSystem, propsReadySystem, domIOSystem), { singleton: true });
